module.exports = __webpack_public_path__ + "static/media/edit32d48998.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/edit.svg
// module id = 1514
// module chunks = 0